import EventDescriptionList from "../eventDescriptionList/eventDescriptionList.component";
import CustomTable from "../customTable/customTable.component";
import "./eventDescription.styles.scss"
import Button, { BUTTON_TYPE_CLASSES } from "../button/button.component";

export const DESCRIPTION_TYPE = {
    base: 'base',
    price: 'price',
    list: 'list'
}

const EventDescription = ({type, adventure}) => {
    return(
    <>
        <div className="event-description">
            {
                type === DESCRIPTION_TYPE.base ? 
                <div className="event-description__itenarary">
                    <div 
                        className="u-margin-bottom-small"
                        dangerouslySetInnerHTML={{ __html: adventure?.description }}
                    >
                    </div>
                        
                    <h3 className="header__tertiary--blue">Itinerary</h3>
                    <div
                        className="event-description__itenarary-list u-margin-bottom-small"
                        dangerouslySetInnerHTML={{ __html: adventure?.itinerary}}
                    >
                    </div>
                    <div className = "u-margin-bottom-small">
                        <EventDescriptionList header="What to wear" list={["Breathable T-shirt", "Gym tights/cargo pants", "Fleece jacket", "Sun hat/cap", "Waterproof shoes"]}/>
                    </div>
                    <div className = "u-margin-bottom-small">
                        <EventDescriptionList header="What to Carry" list={["Identification documents", "3L water (carry a reusable water bottle or hydration pack)", "Suitable snacks(i.e,. trail mix(nuts), energy bars, fruit salads, sandwiches, biscuits)", "Rain gear(poncho, rain pants& leg gaiters)", "Hiking Pole"]}/>
                    </div>
                </div>
                : 
                <div className="event-description__price">
                   <div className="event-description__price-table">
                        <h3 className="header__tertiary--blue u-margin-bottom-tiny">Pricing</h3>
                        <div className="u-margin-bottom-small">
                            <CustomTable headers={["Ticket", "Per person", "self-drive"]} values={[["Citizens", "2500", "5500"], ["Residents", "4500", "7500"], ["Non-residents", "2500", "5500"]]}/>
                        </div>
                        <div className="u-margin-bottom-small">
                            <EventDescriptionList header="Package Includes" list={["Transport in a coaster bus", "Hiking/guiding fees", "Paramedic services", "Full-board accommodation in mountain huts with mattresses", "Support of porters, cooks, and guides"]}/>
                        </div>
                       <div className="u-margin-bottom-small">
                            <EventDescriptionList header="Package Does Not Include" list={["Hiking gear, sleeping bag, porter bag, and personal items", "Tips for guides, porters, and cooks", "Health and travel insurance", "SAnything not mentioned above"]}/>
                       </div>
                       <div className="u-margin-bottom-small">
                            <EventDescriptionList header="Cancellation Policy" list={["Hiking gear, sleeping bag, porter bag, and personal items", "Tips for guides, porters, and cooks", "Health and travel insurance", "SAnything not mentioned above"]}/>
                       </div>
                   </div>
                </div>
            }
            <div className="event-description__book">
                <Button buttonType={BUTTON_TYPE_CLASSES.eventButton} buttonclassName="btn__blue">Book Now</Button>
            </div>
        </div>
    </>
    )
}

export default EventDescription;